import React, { useEffect } from 'react';
import { Card, Col, Divider, Row, Typography, 
        //  Button 
        } from 'antd';
import { RocketOutlined, InfoCircleOutlined, StarFilled, BookOutlined, ExperimentOutlined, MedicineBoxOutlined } from '@ant-design/icons';
import { ReactComponent as Banner } from '../../media/banner.svg';

const { Title, Paragraph, Text } = Typography;

const Home_new = ({ core }) => {
  useEffect(() => {
    document.title = 'SALUDATA | Inicio';
    core.setHome(true);
    return () => {
      core.setHome(false);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {/* Información institucional del nuevo gobierno */}

      <Banner id="home__banner" />
      <Row justify="center" style={{ marginTop: 32 }}>
        <Col xs={24} md={20} lg={16}>
          <Card bordered style={{ borderRadius: 12, boxShadow: '0 4px 24px rgba(0,0,0,0.08)' }}>
            <Title level={2} style={{ color: '#1890ff', marginBottom: 0 }}>
              <RocketOutlined /> Investigación en Salud (SDS)
            </Title>
            <Paragraph style={{ fontSize: 18, margin: '16px 0' }}>
              En este espacio descubrirá los proyectos y productos de conocimiento en investigación, desarrollados con el respaldo y la cofinanciación de la Secretaría Distrital de Salud de Bogotá.
            </Paragraph>
            <Divider />
            <Row gutter={[16, 16]}>
              <Col xs={24} md={12}>
                <Card bordered={false} style={{ background: '#e6f7ff', borderRadius: 8 }}>
                  <Title level={4} style={{ color: '#1890ff', marginBottom: 8 }}>
                    <StarFilled style={{ color: '#faad14' }} /> Novedades 2025
                  </Title>
                  <ul style={{ fontSize: 16, paddingLeft: 20 }}>
                    <li>Nuevo tablero con listado de proyectos financiados por la SDS y ATENEA 2021-2024.</li>
                    <li>Convocatorias y becas vigentes.</li>
                    {/* <li>Visualización mejorada de datos territoriales</li> */}
                  </ul>
                </Card>
              </Col>
              <Col xs={24} md={12}>
                <Card bordered={false} style={{ background: '#fffbe6', borderRadius: 8 }}>
                  <Title level={4} style={{ color: '#faad14', marginBottom: 8 }}>
                    <InfoCircleOutlined /> Recursos proximamente disponibles
                  </Title>
                  <ul style={{ fontSize: 16, paddingLeft: 20 }}>
                    <li>Blog de entrevistas a investigadores de salud.</li>
                    <li>Podcasts en investigación en salud de Bogotá.</li>
                    {/* <li>Soporte y contacto institucional</li> */}
                  </ul>
                </Card>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
      <Row justify="center" style={{ marginTop: 32, marginBottom: 16 }}>
        <Col xs={24} md={20} lg={16}>
          <Card bordered={false} style={{ background: '#f0f5ff', borderRadius: 12, marginBottom: 16 }}>
            <Title level={3} style={{ color: '#1890ff', marginBottom: 8 }}>
              Bogotá sociedad del conocimiento
            </Title>
            <Paragraph style={{ fontSize: 17, marginBottom: 16,  }} > 
              La Política Pública De Ciencia, Tecnología e Innovación 2019-2038, busca “<strong><em>fortalecer el Ecosistema Regional de Ciencia, Tecnología e Innovación para lograr insertar a Bogotá dentro de las denominadas sociedades de conocimiento, como una ciudad-región competitiva, sostenible, innovadora, e integradora con base a su capacidad para crear valor por medio de la generación y aplicación de conocimiento”</em></strong>.  
              {/* Como parte del programa de Gobierno <strong><em>Bogotá Camina segura</em> 2024 - 2027</strong>,  bajo el liderazgo del alcalde <b>Carlos Fernando Galán</b>. Se ha definido una agenda ambiciosa que integra la educación, la investigación y la salud como ejes estratégicos del desarrollo de la ciudad. */}
            </Paragraph>
            <Paragraph style={{ fontSize: 16, marginBottom: 8 }}>
              Con sus cuatro objetivos específicos:
            </Paragraph>
            <ul style={{ fontSize: 16, marginBottom: 12, paddingLeft: 24 }}>
              <li style={{ marginBottom: 8 }}>
                <BookOutlined style={{ color: '#1890ff', marginRight: 8 }} />
                <b>1.</b> Consolidar a la Educación y la Investigación con enfoque al desarrollo de capacidades endógenas en Ciencia, Tecnología e Innovación.  
              </li>
              <li style={{ marginBottom: 8 }}>
                <ExperimentOutlined style={{ color: '#52c41a', marginRight: 8 }} />
                <b>2.</b> Potenciar la innovación empresarial y la competitividad de las cadenas de producción.  
              </li>
              <li style={{ marginBottom: 8 }}>
                <MedicineBoxOutlined style={{ color: '#faad14', marginRight: 8 }} />
                <b>3.</b> Generar procesos de Innovación Social y Pública que aporten a lograr un Desarrollo Humano Sostenible. 
              </li>
              <li style={{ marginBottom: 8 }}>
                <MedicineBoxOutlined style={{ color: '#faad14', marginRight: 8 }} />
                <b>4.</b> Consolidar el Sistema Distrital de CT+I en salud para el abordaje equitativo de las necesidades y retos de salud y bienestar de la población de Bogotá. 
              </li>
            </ul>
            <Paragraph style={{ fontSize: 16, marginBottom: 0 }}>
              <Text strong>Con esto en mente, este portal ha sido actualizado para visibilizar los proyectos, convocatorias y actores clave en la investigación en salud en Bogotá. </Text>
            </Paragraph>
          </Card>
        </Col>
      </Row>

    </>
  );
};

export default Home_new; 